import React from "react";
import { useNavigate } from "react-router-dom";
import errorImage from "../images/error.png"; // your existing image
import "../css/Custom404.css";

const Custom404 = () => {
  const navigate = useNavigate();

  return (
    <div className="notfound-wrapper">
      <div className="notfound-container">
        <h1 className="notfound-code">404</h1>
        {/* <img src={errorImage} alt="404" className="notfound-image" /> */}
        <h2 className="notfound-title">Oops! Page Not Found</h2>
        <p className="notfound-text">
          Looks like the page you’re trying to reach doesn’t exist or has been moved.
        </p>
        <button className="notfound-btn" onClick={() => navigate("/")}>
          Go Back Home
        </button>
      </div>

      <div className="notfound-bg-shapes">
        <div className="circle"></div>
        <div className="triangle"></div>
        <div className="square"></div>
      </div>
    </div>
  );
};

export default Custom404;
